import { PointExpression } from 'leaflet';
import { Season } from 'src/app/core/domain/season.enum';
import { WritablePart } from 'src/app/core/utils/type-helper';
import { MapElement } from 'src/app/maps/domain/masterdata/map-element.model';
import { MapPosition } from 'src/app/maps/domain/masterdata/map-position.model';
import { SisMapAssetCategory } from 'src/app/maps/domain/masterdata/sismap-asset-category.enum';
import { AssetStatus } from '../livedata/status.enum';
import { AssetSubStatus } from '../livedata/substatus.enum';

export class Wind implements MapElement {
  static readonly defaultIconSize: PointExpression = [60, 60];
  static readonly empty: Wind = new Wind({ guid: undefined });

  readonly category = SisMapAssetCategory.Wind;

  guid: string;
  name: string;
  season: Season;
  type: string;

  iconPositions: MapPosition[];
  iconWidth: number;
  iconHeight: number;
  iconUseMeteoData?: boolean;

  meteoStationSisId: string;
  directionOffsetPanoMap: number;
  directionOffsetNorth: number;

  windSpeedKmh: number | null;
  windDirectionDegreeAxis: number | null;
  windDirectionDegreeNorth: number | null;

  label?: string;
  status?: AssetStatus;
  subStatus?: AssetSubStatus;
  disallowPopUp: boolean;
  disallowHighlight: boolean;
  isCategorySki: boolean;
  isGrey: boolean;
  path?: string;
  pathDashArray?: string;
  pathWeight?: number;
  pathColor?: string;
  pathBackgroundColor?: string;
  defaultPathWeight: number;
  defaultPathColor: string;
  iconAlwaysOnTop?: boolean;
  iconDisableBaseZoom?: boolean;
  iconImageName?: string;
  iconSvgBlobName?: string;
  iconHtml?: string;
  iconUseStatus?: boolean;
  newlyAdded?: boolean;

  constructor(init?: Partial<WritablePart<Wind>>) {
    Object.assign(this, init);
  }
}
